module.exports = __webpack_public_path__ + "img/milestone__01.7769d101.png";